import { render, staticRenderFns } from "./TradingTrades.vue?vue&type=template&id=ce9c4ac2&scoped=true&"
import script from "./TradingTrades.vue?vue&type=script&lang=js&"
export * from "./TradingTrades.vue?vue&type=script&lang=js&"
import style0 from "./TradingTrades.vue?vue&type=style&index=0&id=ce9c4ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9c4ac2",
  null
  
)

export default component.exports